import React, { useEffect, useState } from "react";
import { Badge, Button, Form, Modal, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getRegionDetail } from "../../api/User/commonApi";
import {
  GetUserRegionsRequestData,
  requestMoreRegion,
} from "../../api/Admin/serviceApi";
import Fontstyling, { tablestyle } from "../../components/common/comman";
import "react-toastify/dist/ReactToastify.css";
import theme from "../../Utils/theme";
import NoDataMassage from "../../components/common/NoDataMassage";
import Loader from "../../components/common/Loader";
import toastFile from "../../Service/ToastFile";
import SBARFormRequest from "./SBARFormRequest";

const ServiceRequest = ({ navigate }) => {
  const user = useSelector((state) => state.userDetails.value);
  const [isVisible, setIsVisible] = useState(false);
  const [regionData, setRegionData] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [alreadyRequestedData, setAlreadyRequestedData] = useState([]);
  const [requestedData, setRequestedData] = useState([]);

  useEffect(() => {
    getRegionData();
  }, []);

  useEffect(() => {
    if (isSubmit) {
      getRegionData();
      toastFile("You requested more hub region successfully",'success');
      setIsSubmit(false);
    }
    if (isEmpty) {
      toastFile("Please select at least 1 hub region",'warning');
      setIsEmpty(false);
    }
  }, [isSubmit, isEmpty]);

  const getRegionData = async () => {
    setIsLoading(true);
    let uniqueRegion = [];
    let requestedData = [];
    await GetUserRegionsRequestData(user?.UD_id).then((res) => {
      if(res?.status === 200 || res?.status === 204){
      requestedData = res.data;
      setRequestedData(res.data);
      setIsLoading(false);
      }
    });
    await getRegionDetail()
      .then((res) => {
        if(res?.status === 200 || res?.status === 204){
        uniqueRegion = [
          ...new Map(res.data.map((obj) => [obj["hubRegion"], obj])).values(),
        ];
      }
      setIsLoading(false)
      })
    var result = [];
    for (var i = 0; i < requestedData.length; ++i) {
      result.push(requestedData[i].HubRegion);
    }
    setAlreadyRequestedData(result);
    setRegionData(uniqueRegion);
  };

  return (
    <>
      <MyVerticallyCenteredModal
        show={isVisible}
        onHide={() => setIsVisible(false)}
        data={regionData}
        setIsSubmit={setIsSubmit}
        setIsEmpty={setIsEmpty}
        requestedData={alreadyRequestedData}
      />

      <div className="row mt-3">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div style={{ ...Fontstyling.heading }}>Your requested Regions</div>
            <div className="text-end">
              <button
                onClick={() => setIsVisible(true)}
                className="primary-button px-3 m-0 text-nowrap"
                style={Fontstyling.addnewbutton}
              >
                Request New Region
              </button>
            </div>
          </div>
          <Table
            responsive
            bordered
            className="m-0"
            //size="sm"
            style={{ fontSize: "12px" }}
          >
            <thead
              className="py-2"
              style={{
                backgroundColor: theme.SECONDARY_CLASSIC_DARK,
                color: theme.SECONDARY_EGGSHELL_WHITE,
                ...tablestyle.tableheading,
              }}
            >
              <tr>
                <th>Region Name</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody style={tablestyle.tabledata}>
              {requestedData.length && !isLoading
                ? requestedData.map((item, index) => {
                    let badgeColor;
                    switch (item.Status) {
                      case "Approved":
                        badgeColor = "primary";
                        break;
                      case "Rejected":
                        badgeColor = "danger";
                        break;
                      case "Pending":
                        badgeColor = "warning";
                        break;
                    }
                    return (
                      <tr key={index}>
                        <td>{item.HubRegion}</td>
                        <td>
                          <Badge
                            pill
                            className="fw-normal py-1 px-3"
                            bg={badgeColor}
                            style={{ fontSize: "10px" }}
                          >
                            {item.Status}
                          </Badge>
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </Table>
          {isLoading ? (
            <Loader />
          ) : requestedData.length === 0 ? (
            <NoDataMassage massage="No records to display" />
          ) : null}
        </div>
      </div>
    </>
  );
};

export default ServiceRequest;

function MyVerticallyCenteredModal({
  show,
  onHide,
  data,
  setIsSubmit,
  setIsEmpty,
  requestedData,
}) {
  const user = useSelector((state) => state.userDetails.value);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const handleOnChange = (value) => {
    let index = selectedRegion.indexOf(value);
    if (index === -1) {
      setSelectedRegion([...selectedRegion, value]);
    } else {
      selectedRegion.splice(index, 1);
      setSelectedRegion(selectedRegion);
    }
  };
  const onSubmit = () => {
    let regionID = "";
    if (selectedRegion.length > 0) {
      selectedRegion.map((item, index) => {
        if (index === 0) {
          regionID = item;
        } else {
          regionID = regionID + "," + item;
        }
      });
      let payload = {
        udR_UD_id: user?.UD_id,
        udR_Region_id: regionID,
      };
      requestMoreRegion(payload)
        .then((res) => {
          if(res?.status === 200 || res?.status === 204){
          setSelectedRegion([]);
          }
        })
        .catch((err) => {
          console.log({ err });
        });
      setIsSubmit(true);
      onHide();
    } else {
      setIsEmpty(true);
    }
  };

  return (
    <Modal show={show} onHide={onHide} animation={false} centered>
      <Modal.Header closeButton>
        <Modal.Title
          style={{ ...Fontstyling.sidebarheading, fontSize: "14px" }}
        >
          Select More Regions
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="row">
            {requestedData.length === data.length ? (
              <div>No More Region Available</div>
            ) : (
              data.map((item, index) => {
                let disable = false;
                if (requestedData.includes(item.hubRegion)) {
                  disable = true;
                }
                return (
                  <Form.Group
                    className={disable ? "d-none" : `mb-3 col-4`}
                    controlId="formBasicCheckbox"
                  >
                    <Form.Check
                      id={index}
                      type="checkbox"
                      style={Fontstyling.label}
                      label={item.hubRegion}
                      name={item.hubRegion}
                      value={item.regionID}
                      onChange={(e) => handleOnChange(e.target.value)}
                    />
                  </Form.Group>
                );
              })
            )}
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          style={Fontstyling.cancelbutton}
          onClick={onHide}
        >
          Close
        </Button>
        <Button variant="primary" className="primary-button" onClick={onSubmit}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
